'use client';

import { useTranslations, useLocale } from 'next-intl';
import { useScrollAnimation } from '@/hooks/use-scroll-animation';
import { SectionWrapper } from '@/components/ui/section-wrapper';
import { SectionHeading } from '@/components/frontend/home/section-heading';
import { IndustrySolutionsGrid } from '@/components/frontend/industry-solutions/industry-solutions-grid';
import { Button } from '@/components/ui/button';
import { getLocalizedPath } from '@/lib/locale-utils';

type IndustryItem = { id: string; title: string; description: string; icon: string };

export function IndustrySolutions({ initialIndustries }: { initialIndustries?: IndustryItem[] } = {}) {
    const t = useTranslations('home.industrySolutions');
    const sectionRef = useScrollAnimation({ threshold: 0.15 });
    const locale = useLocale();

  return (
        <SectionWrapper
            ref={sectionRef.ref}
            variant="default"
            padding="md"
            className="relative"
        >
            {/* Background accents */}
            <div className="pointer-events-none absolute inset-0 opacity-60">
                <div className="absolute -left-32 top-10 h-64 w-64 rounded-full bg-primary-500/10 blur-3xl" />
                <div className="absolute right-0 bottom-0 h-72 w-72 rounded-full bg-blue-500/10 blur-3xl" />
            </div>

            <div className="relative z-10">
                {/* Header */}
                <SectionHeading
                    pill={t('pillLabel')}
                    title={t('title')}
                    subtitle={t('subtitle')}
                    isVisible={sectionRef.isVisible}
                />

                {/* Industry Cards Grid */}
                <IndustrySolutionsGrid limit={6} showOnHomePageOnly={true} initialSolutions={initialIndustries} />

                {/* View All Industries Button */}
                <div className="mt-16 flex justify-center">
                    <Button
                        href={getLocalizedPath('industry-solutions', locale)}
                        variant="primary"
                        size="md" className="w-full sm:w-auto justify-center"
                        showArrow={true}
                    >
                        {t('viewAllButton')}
                    </Button>
                </div>
            </div>
        </SectionWrapper>
    );
}

